import React from 'react';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import CustomRadio from 'components/CustomRadio/CustomRadio';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/users/detailsStyle';
import { translate } from 'components/Translation';
import { BodyS } from 'components/Typography/Typography';
import { SingleCorpAccount } from 'utils/api/models/accounts/singleCorpAccount';
import { MAX_ADMIN_COUNT } from 'utils/const/users';
import { UserType } from 'views/Users/UsersList';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IEditTypeProps {
	hideDialog: () => void;
	formData: {
		type: types.users.userType;
	};
	setFormData: (key: 'type', value: types.users.userType) => void;
	handleSave: () => void;
	accounts: SingleCorpAccount[];
	user: types.users.IExtendedCorpUserDetails;
}

const EditType = ({ hideDialog, formData, setFormData, handleSave, accounts, user }: IEditTypeProps) => {
	const classes = useStyles();
	const userAccount = accounts?.find((account) => account?.accountName === user?.userData?.accountName);
	const adminButtonDisabled =
		userAccount && user?.userData?.userType !== UserType.ADMIN && userAccount?.adminsCount >= MAX_ADMIN_COUNT;

	return (
		<CustomDialog
			isOpen
			hideDialog={hideDialog}
			header={translate('users.details.editType')}
			rightSideButtons={[
				{
					text: translate('cancel'),
					onClick: hideDialog,
					color: 'tertiary-light',
					id: 'cancel-button',
				},
				{
					text: translate('save'),
					onClick: handleSave,
					color: 'primary-light',
				},
			]}
			dialogBody={
				<div className={classes.editTypeDialogContainer}>
					<BodyS>{translate('select.user.type')}</BodyS>
					{['ENDUSER', 'MANAGER', 'ADMIN'].map((type) => (
						<div key={type}>
							<CustomRadio
								checked={formData.type === type}
								label={translate(`user.type.${type.toLowerCase()}`)}
								onChange={() => setFormData('type', type as types.users.userType)}
								disabled={type === UserType.ADMIN && adminButtonDisabled}
							/>
						</div>
					))}
				</div>
			}
		/>
	);
};

export default EditType;
